import { OpenStreetMapImageryProvider } from 'cesium'
import imageryDefault from './../assets/images/imagery/bingAerial.png'
import imageryOpenStreetMap from './../assets/images/imagery/openStreetMap.png'
import { ImageryDataType } from './utils.types'

export const imageryData: ImageryDataType[] = [
	{
		name: 'Default',
		src: imageryDefault,
	},
	{
		name: 'OpenStreetMap',
		src: imageryOpenStreetMap,
		provider: new OpenStreetMapImageryProvider({
			url: 'https://a.tile.openstreetmap.org/',
		}),
	},
]
